import React from 'react';
import Tokens from '@nokia-csf-uxr/freeform-design-tokens';
import HelpCircleIcon from '@nokia-csf-uxr/ccfk-assets/HelpCircleIcon';

import IconButton from 'components/IconButton';

const ICON_BUTTON_CONFIG = {
  tabIndex: -1,
  rippleStyle: { marginLeft: Tokens.SPACING.SPACING_4, marginBottom: Tokens.SPACING.SPACING_4 },
  size: 'small' as const
};

export interface LabelHelpIconProps extends React.ComponentPropsWithRef<'button'> {
  /** To override the HelpIcon pass any other icon. */
  children?: React.ReactNode;
}

/**
 * Any other props than `children` will be provided to the root `button` element.
 * To get the ref of the outermost element use `ref` prop. [Read React useRef hook documentation](https://reactjs.org/docs/hooks-reference.
 */
const LabelHelpIcon = React.forwardRef<HTMLElement, LabelHelpIconProps>((props: LabelHelpIconProps, ref) => {
  const { children, ...otherProps } = props;
  return (
    <IconButton ref={ref} {...ICON_BUTTON_CONFIG} {...otherProps}>
      {children}
    </IconButton>
  );
});

LabelHelpIcon.displayName = 'LabelHelpIcon';

LabelHelpIcon.defaultProps = {
  children: <HelpCircleIcon />
};

export default LabelHelpIcon;
